<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

*, html, body {
  margin: 0;
  padding: 0;
  color: #ffffff;
}

html, body {
  background-color: rgb(31, 31, 31);
}

#app {
  font-family: 'Inconsolata', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.panel {
  padding: 20px;
  background-color: rgb(99, 99, 99);
  border-radius: 6px;
}

.field {
  margin: 10px 0;
  display: flex;
}

textarea, select, input, button { outline: none; }

input, button {
  background-color: transparent;
  border: none;
  color: inherit;
}

input {
  border-bottom: 2px solid black;
  padding: 2px;
}

button {
  background-color: white;
  color: black;
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;

  transition: 200ms;
}

button:hover {
  background-color: rgb(61, 61, 61);
  color: white;
}

button:active {
  background-color: rgb(0, 0, 0);
  color: white;
}

.resize {
  transform: scale(1);
  transition: 200ms;
}

.resize:hover {
  transform: scale(1.1)!important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue